import React from "react";
import styled from "styled-components";
import { Flex } from "../../components";

const ModalWrapper = styled(Flex)`
  display: ${({ open }) => (open ? "display" : "none")};
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  margin: 0 auto;
  background: rgba(0, 0, 0, 0.1);
`;

const ModalTextWrapper = styled(Flex)`
  width: 25vw;
  border: 1px solid #ccc;
  border-radius: .5em;
  background: #fff;
  @media(max-width:767px){
    width:90%;
    height: 80%;
    overflow:auto;
  }
`;

const TestDescriptionWrapper = styled.div`
  display: grid;
  grid-gap: 2rem;
  margin-bottom: 6rem;
  img {
    width: 100%;
  }
  @media (max-width: 768px) {
    grid-template-columns: auto;
  }
`;

const noActionCallback = (event) => {
  event.stopPropagation();
  return
}

const Modal = ({ open, callBack, name, description, expiryTime, timelimit, sections }) => (

  <ModalWrapper onClick={callBack} center open={open}>
    <ModalTextWrapper onClick={noActionCallback} column>
      <div style={{ padding: '20px 10px 20px 0' }}>
        <Flex column center>
          <div>
            {/* <h1 style={{ margin: '0.3em 0', fontSize: '28px', textAlign: 'center', marginTop:'30px' }}>{name}</h1> */}
            <TestDescriptionWrapper>
              {/* {test_img &&
            <img
              src={test_img}
              alt=""
            />
          } */}
              <Flex column>
                {/* <div style={{width: '30px', margin: 'auto', marginRight: '10px'}}>
                    <img onClick={callBack} style={{cursor: 'pointer'}} src='/images/x-mark.svg'></img>
                </div> */}
                <div>
                  <h3 style={{ fontSize: '20px', margin: '0.3 0', textAlign: 'center', fontWeight: '600' }}>Instructions</h3>
                  <ul>
                    {sections.length != 0 ? <li>
                      <b>There are {sections.length} sections in this test.</b>
                      <ul style={{ paddingLeft: '20px', fontWeight: 'bold' }}>
                        {sections.map((sec, index) => {
                          return <li key={index}>
                            <div style={{ fontWeight: 'bold' }}> Section {index + 1} :</div>

                            <div style={{ fontStyle: 'italic' }}>Name: {sec.name}</div>
                            <div style={{ fontStyle: 'italic' }}>Marks: {sec.marks}</div>
                            {sec.instructions && <div>Instructions: {sec.instructions}</div>}
                          </li>
                        })}
                      </ul>
                    </li> : null}
                    <li>
                      <b>Make sure that you don’t switch the app. Switching more than twice submits the test.</b>
                    </li>
                    <li>
                      <b>Please put your phone in Do-Not-Disturb (DND) mode while taking the test.</b>
                    </li>
                    <li>
                      Total Duration of test is allocated by the faculty and is shown on the top of the test screen.
                </li>
                    <li>
                      The Test should be taken within the time of expiry as mentioned by the faculty.
                </li>
                    <li>
                      The test will be Multiple choice questions with a single correct answer.
                </li>
                    <li>
                      There is no negative marking for the incorrectly answered questions.
                </li>
                    <li>
                      One point will be awarded for each correctly answered question.
                </li>
                    <li>
                      The Test will be auto-submitted once the allocated duration of the test completes.
                </li>
                    <li>
                      There will be four level of questions: Remembering, Understanding, Applying and Analyzing.
                </li>
                    <li>
                      The results for the test will auto-appear once the test gets expired.
                </li>
                    <li>
                      The detailed report for the test and correct answers will be shown in the results.
                </li>
                    <li>WARNING:  You are not allowed to take any screenshots during the test, this may effect your scores. </li>
                    <li>
                      The scores generated in the test will have a huge impact on your performance analytics.
                </li>
                  </ul>
                </div>
              </Flex>
            </TestDescriptionWrapper>
          </div>

        </Flex>
      </div>
    </ModalTextWrapper>
  </ModalWrapper>
);

export default Modal;
